import fileDownload from "js-file-download";
import logisticReportsService from "../shared/services/logisticReportsService";

const REQUEST_CHANGE_TIME_LOGISTIC_REPORT = "REQUEST_CHANGE_TIME_LOGISTIC_REPORT";
const READY_CHANGE_TIME_LOGISTIC_REPORT = "READY_CHANGE_TIME_LOGISTIC_REPORT";
const RESET_TIME_LOGISTIC_REPORT = "RESET_TIME_LOGISTIC_REPORT";

const requestChangeTimeLogisticReportAction = () => {
  return {
    type: REQUEST_CHANGE_TIME_LOGISTIC_REPORT,
  };
};

const responseChangeTimeLogisticReportAction = (name, value) => {
  return {
    type: READY_CHANGE_TIME_LOGISTIC_REPORT,
    payload: { name, value },
  };
};

const changeTimeLogisticReport = (name, value) => {
  return (dispatch) => {
    dispatch(responseChangeTimeLogisticReportAction(name, value));
  };
};

const resetTimeLogisticReportAction = () => {
  return {
    type: RESET_TIME_LOGISTIC_REPORT,
  };
};

const CHANGE_SEARCH_TERM_LOGISIC_REPORT = "CHANGE_SEARCH_TERM_LOGISIC_REPORT";

const responseChangeSearchTermLogisticReportAction = (data) => {
  return {
    type: CHANGE_SEARCH_TERM_LOGISIC_REPORT,
    data,
  };
};

const changeSearchTermLogisticReport = (data) => {
  return (dispatch) => {
    dispatch(responseChangeSearchTermLogisticReportAction(data));
  };
};

const REQUEST_CP_REPORTS = "REQUEST_CP_REPORTS";
const RESPONSE_CP_REPORTS = "RESPONSE_CP_REPORTS";
const REQUEST_CP_REPORTS_FAILURE = "REQUEST_CP_REPORTS_FAILURE";

const requestControlPointsReportsAction = () => {
  return {
    type: REQUEST_CP_REPORTS,
  };
};

const responseControlPointsReportsAction = (data) => {
  return {
    type: RESPONSE_CP_REPORTS,
    data,
  };
};

const requestControlPointsReportsFailureAction = (errors) => {
  return {
    type: REQUEST_CP_REPORTS_FAILURE,
    errors,
  };
};

const getControlPointsReports = (options = {}) => {
  return (dispatch) => {
    dispatch(requestControlPointsReportsAction());

    logisticReportsService
      .getLogisticControlPointsReports(options)
      .then((result) => {
        dispatch(responseControlPointsReportsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestControlPointsReportsFailureAction(error.response));
      });
  };
};

const REQUEST_TASK_TRIPS_REPORTS = "REQUEST_TASK_TRIPS_REPORTS";
const RESPONSE_TASK_TRIPS_REPORTS = "RESPONSE_TASK_TRIPS_REPORTS";
const REQUEST_TASK_TRIPS_REPORTS_FAILURE = "REQUEST_TASK_TRIPS_REPORTS_FAILURE";

const requestTaskTripsReportsAction = () => {
  return {
    type: REQUEST_TASK_TRIPS_REPORTS,
  };
};

const responseTaskTripsReportsAction = (data) => {
  return {
    type: RESPONSE_TASK_TRIPS_REPORTS,
    data,
  };
};

const requestTaskTripsReportsFailureAction = (errors) => {
  return {
    type: REQUEST_TASK_TRIPS_REPORTS_FAILURE,
    errors,
  };
};

const getTaskTripsReports = (options = {}) => {
  return (dispatch) => {
    dispatch(requestTaskTripsReportsAction());

    logisticReportsService
      .getLogisticTaskTrpsReports(options)
      .then((result) => {
        dispatch(responseTaskTripsReportsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestTaskTripsReportsFailureAction(error.response));
      });
  };
};

const REQUEST_TASK_TRIP_REPORT = "REQUEST_TASK_TRIP_REPORT";
const RESPONSE_TASK_TRIP_REPORT = "RESPONSE_TASK_TRIP_REPORT";
const REQUEST_TASK_TRIP_REPORT_FAILURE = "REQUEST_TASK_TRIP_REPORT_FAILURE";

const requestTaskTripReportAction = () => {
  return {
    type: REQUEST_TASK_TRIP_REPORT,
  };
};

const responseTaskTripReportAction = (data) => {
  return {
    type: RESPONSE_TASK_TRIP_REPORT,
    data,
  };
};

const requestTaskTripReportFailureAction = (errors) => {
  return {
    type: REQUEST_TASK_TRIP_REPORT_FAILURE,
    errors,
  };
};

const getTaskTripReport = (options = {}) => {
  return (dispatch) => {
    dispatch(requestTaskTripReportAction());

    logisticReportsService
      .getLogisticTaskTrpReport(options)
      .then((result) => {
        dispatch(responseTaskTripReportAction(result.data));
      })
      .catch((error) => {
        dispatch(requestTaskTripReportFailureAction(error.response));
      });
  };
};

const clearTaskTripReport = (options = {}) => {
  return (dispatch) => {
    dispatch(responseTaskTripReportAction(null));
  };
};

const REQUEST_TASK_TRIP_REPORT_DOWNLOAD = "REQUEST_TASK_TRIP_REPORT_DOWNLOAD";
const RESPONSE_TASK_TRIP_REPORT_DOWNLOAD = "RESPONSE_TASK_TRIP_REPORT_DOWNLOAD";
const REQUEST_TASK_TRIP_REPORT_DOWNLOAD_FAILURE = "REQUEST_TASK_TRIP_REPORT_DOWNLOAD_FAILURE";

const requestTaskTripReportDownloadAction = () => {
  return {
    type: REQUEST_TASK_TRIP_REPORT_DOWNLOAD,
  };
};

const responseTaskTripReportDownloadAction = (data) => {
  return {
    type: RESPONSE_TASK_TRIP_REPORT_DOWNLOAD,
  };
};

const requestTaskTripReportDownloadFailureAction = (errors) => {
  return {
    type: REQUEST_TASK_TRIP_REPORT_DOWNLOAD_FAILURE,
    errors,
  };
};

const logisticTaskTrpReportDownload = (options, title) => {
  return (dispatch) => {
    dispatch(requestTaskTripReportDownloadAction());
    logisticReportsService
      .logisticTaskTrpReportDownload(options)
      .then((result) => {
        fileDownload(result.data, `${title}.xlsx`);
        dispatch(responseTaskTripReportDownloadAction());
      })
      .catch((error) => {
        dispatch(requestTaskTripReportDownloadFailureAction(error.response));
      });
  };
};

export {
  REQUEST_CHANGE_TIME_LOGISTIC_REPORT,
  READY_CHANGE_TIME_LOGISTIC_REPORT,
  RESET_TIME_LOGISTIC_REPORT,
  changeTimeLogisticReport,
  requestChangeTimeLogisticReportAction,
  responseChangeTimeLogisticReportAction,
  resetTimeLogisticReportAction,
  CHANGE_SEARCH_TERM_LOGISIC_REPORT,
  changeSearchTermLogisticReport,
  REQUEST_CP_REPORTS,
  RESPONSE_CP_REPORTS,
  REQUEST_CP_REPORTS_FAILURE,
  getControlPointsReports,
  REQUEST_TASK_TRIPS_REPORTS,
  RESPONSE_TASK_TRIPS_REPORTS,
  REQUEST_TASK_TRIPS_REPORTS_FAILURE,
  getTaskTripsReports,
  REQUEST_TASK_TRIP_REPORT,
  RESPONSE_TASK_TRIP_REPORT,
  REQUEST_TASK_TRIP_REPORT_FAILURE,
  getTaskTripReport,
  clearTaskTripReport,
  REQUEST_TASK_TRIP_REPORT_DOWNLOAD,
  RESPONSE_TASK_TRIP_REPORT_DOWNLOAD,
  REQUEST_TASK_TRIP_REPORT_DOWNLOAD_FAILURE,
  logisticTaskTrpReportDownload,
};
